module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.0995d0f0.jpg";